import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop, faClock, faCircleCheck, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { getDevicesCards } from "../../apis/axios";
import React, { useEffect, useState, useContext } from 'react';
import AuthContext from "../../AuthContext";

const StatCards = () => {
  const auth = useContext(AuthContext);
  const [devicesData, setDevicesData] = useState(null); // null while loading

  const fetchDevicesData = async () => {
    try {
      const response = await getDevicesCards({ company_id: auth.admin });
      //console.log("Devices Data:", response.data);
      setDevicesData(response.data);
    } catch (error) {
      console.error("Error fetching devices data:", error);
    }
  };

  useEffect(() => {
    fetchDevicesData();
  }, [auth.admin]);

  // Define cards dynamically based on devicesData
  const cardData = [
    {
      title: "Total Devices",
      value: devicesData ? devicesData.devices.totalDevices : "-",
      percentage: devicesData ? `+${devicesData.devices.monthDevices} from last month` : "-",
      icon: <FontAwesomeIcon icon={faDesktop} className="text-green-500 text-3xl" />,
      iconBg: "bg-green-100",
      borderColor: "border-l-green-500",
      textColor: "text-green-500",
    },
    {
      title: "Pending Wipes",
      value: devicesData ? devicesData.wipesPending.total : "-",
      percentage: devicesData ? `+${devicesData.wipesPending.month} from last month` : "-",
      icon: <FontAwesomeIcon icon={faClock} className="text-orange-500 text-3xl" />,
      iconBg: "bg-orange-100",
      borderColor: "border-l-orange-500",
      textColor: "text-orange-500",
    },
    {
      title: "Completed Wipes",
      value: devicesData ? devicesData.totalWipes.total : "-",
      percentage: devicesData ? `+${devicesData.totalWipes.month} from last month` : "-",
      icon: <FontAwesomeIcon icon={faCircleCheck} className="text-blue-500 text-3xl" />,
      iconBg: "bg-blue-100",
      borderColor: "border-l-blue-500",
      textColor: "text-blue-500",
    },
    {
      title: "Failed Wipes",
      value: devicesData ? devicesData.failedWipes.total : "-",
      percentage: devicesData ? `+${devicesData.failedWipes.month} from last month` : "-",
      icon: <FontAwesomeIcon icon={faTriangleExclamation} className="text-red-500 text-3xl" />,
      iconBg: "bg-red-100",
      borderColor: "border-l-red-500",
      textColor: "text-red-500",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-5">
      {cardData.map((card, idx) => (
        <div
          key={idx}
          className={`flex items-center justify-between bg-white shadow-md p-5 rounded-lg border-l-4 ${card.borderColor} hover:shadow-lg transition-all duration-300`}
        >
          <div className="flex flex-col gap-2">
            <h3
              className="text-base font-semibold"
              style={{
                color: "#595C60",
                fontFamily: "Nunito Sans, sans-serif",
                fontWeight: 600,
              }}
            >
              {card.title}
            </h3>
            <p className="text-2xl font-bold text-gray-900">{card.value}</p>
            <p className={`text-sm ${card.textColor}`}>{card.percentage}</p>
          </div>
          <div className={`w-14 h-14 flex items-center justify-center rounded-full ${card.iconBg}`}>
            {card.icon}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatCards;